import React from "react";

/**
 * Professional industrial placeholder used when a product has no verified photo.
 * Matches the white/orange brand theme. Never claim it's the actual unit.
 */
export default function ProductPlaceholder({ brand = "", model = "", size = "md", alt = "Foto produk belum tersedia" }) {
  const isSmall = size === "sm";
  return (
    <div
      role="img"
      aria-label={alt}
      className="w-full h-full relative overflow-hidden flex flex-col items-center justify-center p-4 text-center"
      style={{ background: "linear-gradient(135deg, #FFF7EE 0%, #F8F8F8 100%)" }}
    >
      {/* subtle diagonal stripes */}
      <div className="absolute inset-0 opacity-40" style={{
        backgroundImage: "repeating-linear-gradient(45deg, transparent 0 10px, rgba(255,148,24,0.06) 10px 20px)"
      }} />
      <div className={`relative flex flex-col items-center gap-2 ${isSmall ? "" : "gap-3"}`}>
        <div className={`${isSmall ? "w-10 h-10" : "w-14 h-14"} flex items-center justify-center bg-white border border-[#FFD3A2] rounded-lg shadow-sm`}>
          <svg width={isSmall ? 18 : 24} height={isSmall ? 18 : 24} viewBox="0 0 24 24" fill="none" stroke="#FF9418" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
            <path d="M14.7 6.3a1 1 0 0 0 0 1.4l1.6 1.6a1 1 0 0 0 1.4 0l3.77-3.77a6 6 0 0 1-7.94 7.94l-6.91 6.91a2.12 2.12 0 0 1-3-3l6.91-6.91a6 6 0 0 1 7.94-7.94l-3.76 3.76z"/>
          </svg>
        </div>
        <div className="font-mono-tech text-[10px] uppercase tracking-widest text-[#FF9418] font-bold">
          Foto Produk
        </div>
        <div className={`font-display font-bold text-[#171717] ${isSmall ? "text-xs" : "text-sm"}`}>
          Segera Tersedia
        </div>
        {(brand || model) && (
          <div className={`text-[#737373] ${isSmall ? "text-[10px]" : "text-xs"} font-mono-tech uppercase tracking-wider`}>
            {brand} {model}
          </div>
        )}
      </div>
    </div>
  );
}
